var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondevicessquareheimanPirsensorsolid = function SvgIcondevicessquareheimanPirsensorsolid(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Devices/icon.devices.square.heiman_pirsensor.solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Devices/icon.devices.square.heiman_pirsensor.solid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#666666",
    fill: "#FFFFFF",
    cx: 40,
    cy: 40,
    r: 39.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,14.25 C44.2553634,14.25 48.49116,14.4550597 52.706061,14.8650517 L54.1120893,15.0094014 C56.7295955,15.2924176 59.0931629,16.42883 60.9112071,18.1436152 C62.7292513,19.8584004 64.0017724,22.1515585 64.4371874,24.748075 C65.3122811,29.9653922 65.75,35.0493546 65.75,40 C65.75,44.2391507 65.5465017,48.5759666 65.1396694,53.0092523 L64.9963614,54.4924422 C64.7147508,57.2680253 63.4765625,59.7531998 61.6148812,61.6148812 C59.7531998,63.4765625 57.2680253,64.7147508 54.4924407,64.9963616 C49.5410484,65.4987604 44.7102363,65.75 40,65.75 C35.7608493,65.75 31.4240334,65.5465017 26.9907477,65.1396694 L25.5075578,64.9963614 C22.7319747,64.7147508 20.2468002,63.4765625 18.3851188,61.6148812 C16.5234375,59.7531998 15.2852492,57.2680253 15.0036384,54.4924407 C14.5012396,49.5410484 14.25,44.7102363 14.25,40 C14.25,35.7608493 14.4534983,31.4240334 14.8603306,26.9907477 L15.0036386,25.5075578 C15.2852492,22.7319747 16.5234375,20.2468002 18.3851188,18.3851188 C20.2468002,16.5234375 22.7319747,15.2852492 25.5075593,15.0036384 C30.4589516,14.5012396 35.2897637,14.25 40,14.25 Z",
    id: "Rectangle",
    stroke: "#979797",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#666666",
    cx: 40,
    cy: 12.25,
    r: 1
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondevicessquareheimanPirsensorsolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.devices.square.heiman_pirsensor.solid.c845cf2180607c21bb0e8d6e7c0bf6fd.svg";